import isEmpty from 'lodash/isEmpty';

import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormSlowCustomField,
} from '../../types';
import { FieldInputType } from '../types';
import Input from './Input';

const fieldValidation: FieldValidationFunction<unknown> = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    const errorMessage = validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;

    if (value === null || value === undefined) {
      return errorMessage;
    }

    if (typeof value === 'string') {
      return value.trim() === '' ? errorMessage : undefined;
    }

    if (typeof value === 'number') {
      return value === 0 ? errorMessage : undefined;
    }

    if (isEmpty(value)) {
      return errorMessage;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

// infer instead of hardcodeed unknown
const SlowCustomInputField: FieldInputType<FormSlowCustomField, unknown> = {
  Input,
  type: FieldType.SlowCustom,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default SlowCustomInputField;
